import React from 'react';
import '../styles/AppDownloadPage.css';
import iconphoto from "../../assets/logo_white_bg.png";
const AppDownloadPage = () => {
  const handleAndroidDownload = () => {
    window.open('https://play.google.com/store/apps/details?id=com.indiapropertys.app360', '_blank');
  };

  const handleIOSDownload = () => {
    window.open('https://apps.apple.com/app/your-app-id', '_blank');
  };

  const handleDirectDownload = () => {
    const downloadUrl = 'https://your-cdn.com/360coordinates-latest.apk';
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = '360Coordinates.apk';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="appdownload-coordinates-container">
      {/* Hero Section with Logo */}
      {/* <div className="appdownload-coordinates-hero">
        <div className="appdownload-coordinates-logo">
          <h1 className="appdownload-coordinates-logo-main">360</h1>
          <h2 className="appdownload-coordinates-logo-sub">COORDINATES</h2>
        </div>
        <p className="appdownload-coordinates-tagline">Capture Every Angle, Share Every Moment</p>
        <p className="appdownload-coordinates-description">
          Experience immersive 360-degree photography and videography. 
          Create, share, and explore stunning panoramic content with our cutting-edge technology.
        </p>
      </div> */}

      {/* Features Section */}
      {/* <div className="appdownload-coordinates-features">
        <h2 className="appdownload-coordinates-section-title">Why Choose 360Coordinates?</h2>
        <div className="appdownload-coordinates-grid">
          <div className="appdownload-coordinates-card">
            <div className="appdownload-coordinates-card-icon">
              <img src="https://img.icons8.com/fluency/48/000000/gps-device.png" alt="GPS" />
            </div>
            <h3>Precision Mapping</h3>
            <p>High-accuracy GPS tagging for every 360-degree capture</p>
          </div>
          <div className="appdownload-coordinates-card">
            <div className="appdownload-coordinates-card-icon">
              <img src="https://img.icons8.com/fluency/48/000000/360-view.png" alt="360 View" />
            </div>
            <h3>Seamless Stitching</h3>
            <p>AI-powered automatic panorama stitching technology</p>
          </div>
          <div className="appdownload-coordinates-card">
            <div className="appdownload-coordinates-card-icon">
              <img src="https://img.icons8.com/fluency/48/000000/cloud-backup.png" alt="Cloud Storage" />
            </div>
            <h3>Cloud Storage</h3>
            <p>Secure backup and sync across all your devices</p>
          </div>
          <div className="appdownload-coordinates-card">
            <div className="appdownload-coordinates-card-icon">
              <img src="https://img.icons8.com/fluency/48/000000/share.png" alt="Share" />
            </div>
            <h3>Easy Sharing</h3>
            <p>Share immersive experiences on social media instantly</p>
          </div>
        </div>
      </div> */}

      {/* Download Section with Store Buttons */}
      <div className="appdownload-coordinates-download-section">
        <h2 className="appdownload-coordinates-section-title">Get the 360Coordinates App</h2>
        <p className="appdownload-coordinates-subtitle">Available on Android</p>
        
        <div className="appdownload-coordinates-hero-logo-icon" style={{display:"flex", justifyContent:"center", marginBottom:"20px"}}>
          <img style={{
          height:"100px",
          width:"100px",
          borderRadius:"20px",  
        }} src={iconphoto} alt="360Coordinates Logo" className="appdownload-coordinates-hero-logo-image" />
        </div>
        <div className="appdownload-coordinates-store-buttons">
          <button 
            className="appdownload-coordinates-store-btn appdownload-coordinates-play-store" 
            onClick={handleAndroidDownload}
          >
            <div className="appdownload-coordinates-btn-icon">
              <img src="https://img.icons8.com/color/48/000000/google-play.png" alt="Google Play" />
            </div>
            <div className="appdownload-coordinates-btn-text">
              <span className="appdownload-coordinates-btn-small">GET IT ON</span>
              <span className="appdownload-coordinates-btn-large">Google Play</span>
            </div>
          </button>

          {/* <button 
            className="appdownload-coordinates-store-btn appdownload-coordinates-app-store" 
            onClick={handleIOSDownload}
          >
            <div className="appdownload-coordinates-btn-icon">
              <img src="https://img.icons8.com/ios-filled/50/000000/mac-os.png" alt="App Store" />
            </div>
            <div className="appdownload-coordinates-btn-text">
              <span className="appdownload-coordinates-btn-small">Download on the</span>
              <span className="appdownload-coordinates-btn-large">App Store</span>
            </div>
          </button> */}
        </div>

        {/* <div className="appdownload-coordinates-direct-download">
          <div className="appdownload-coordinates-divider">
            <span>OR</span>
          </div>
          <button 
            className="appdownload-coordinates-direct-btn" 
            onClick={handleDirectDownload}
          >
            <img src="https://img.icons8.com/ios-filled/50/000000/download--v1.png" alt="Download" width="20" height="20" />
            Download APK Directly
          </button>
          <p className="appdownload-coordinates-direct-note">Android APK • Version 2.0.1 • 48 MB</p>
        </div> */}
      </div>

      {/* Info Section */}
      <div className="appdownload-coordinates-info-section">
        <div className="appdownload-coordinates-info">
          <h3>System Requirements</h3>
          <ul>
            <li>Android 8.0 or later / iOS 13.0 or later</li>
            <li>Minimum 4GB RAM</li>
            <li>100MB free storage space</li>
            <li>Camera with gyroscope support</li>
          </ul>
        </div>
        {/* <div className="appdownload-coordinates-visit">
          <h3>Visit Our Website</h3>
          <a href="https://360coordinates.com" target="_blank" rel="noopener noreferrer">
            360coordinates.com
          </a>
          <div className="appdownload-coordinates-website-icon">
            <img src="https://img.icons8.com/fluency/48/000000/domain.png" alt="Website" />
          </div>
        </div> */}
      </div>

      {/* Footer */}
      {/* <footer className="appdownload-coordinates-footer">
        <p>&copy; 2024 360Coordinates. All rights reserved.</p>
        <div className="appdownload-coordinates-footer-links">
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
          <a href="/support">Support</a>
        </div>
      </footer> */}
    </div>
  );
};

export default AppDownloadPage;